import { ListingStats } from '../components/PortfolioFilterBar/models';

export const aggregateStats = (stats: ListingStats) =>
  Object.values(stats).reduce((acc, cur) => acc + Number(cur), 0);
